import { apiMipe } from '@/core/api/';

const apiUrl = 'api/academicyears';

export default {
  async getCurrentAcademicYear() {
    try {
      const { data } = await apiMipe.get(`${apiUrl}/current`);
      if (data) {
        data.name = data.description; //set missing name prop
        return data;
      }
      return null;
    } catch {
      return null;
    }
  },
  async getAcademicYearById(academicYearId) {
    try {
      const { data } = await apiMipe.get(
        `${apiUrl}/getacademicyearbyid/${academicYearId}`
      );
      if (data) {
        data.name = data.description; //set missing name prop
        return data;
      }
      return null;
    } catch {
      return null;
    }
  },
  async getReferralServiceAcademicYears() {
    try {
      const { data } = await apiMipe.get(
        `${apiUrl}/getreferralserviceacademicyears`
      );
      if (data) {
        const mappedResults = data.map(function(element) {
          return {
            id: element.id,
            value: element.year,
            name: element.description,
            isSelected: false,
          };
        });

        return mappedResults;
      }
      return [];
    } catch {
      return [];
    }
  },
  async getReferralAppointment() {
    return await apiMipe.get(`${apiUrl}/referralappointment`);
  },
  async getAvailableMonths(academicYearId) {
    try {
      const { data } = await apiMipe.get(`${apiUrl}/${academicYearId}/months`);
      if (data) {
        return data;
      }
      return [];
    } catch {
      return [];
    }
  },
  async getRegistryVisit() {
    try {
      const { data } = await apiMipe.get(`${apiUrl}/registryvisit`);
      if (data) {
        return data;
      }
    } catch {
      return [];
    }
  },
};
